/*
 * @Author: liyxt
 * @Date: 2020-05-28 14:28:27
 * @LastEditors: liyxt
 * @LastEditTime: 2020-05-28 14:41:44
 * @Description: file content
 */ 
import React, { Component } from 'react';
import OriginButtonGroup from 'bee-button-group';

require('bee-button-group/build/ButtonGroup.css');
require('./index.less');

class ButtonGroup extends Component {
	render() {
		return <OriginButtonGroup {...this.props} />;
	}
}
export default ButtonGroup;
